module.exports = __webpack_public_path__ + "img/link-icon.9ed3f879.svg";